import React from "react";
import blankPhoto from "../../PicesForPages/blank.jpg";
import Staff_RameshNagarajan_2017892 from "../../PicesForPages/Staff_RameshNagarajan_NMLS_2017892.jpg";
import staff_SridharParepalli_1789686 from "../../PicesForPages/Staff_SridharParepalli_NMLS_1789686.jpg";
import staff_VisveshBalasubramanian_2629696 from "../../PicesForPages/staff_VisveshBalasubramanian_NMLS_2629696.jpg";
import staff_RajeshCheruku_NMLS_2658067 from "../../PicesForPages/staff_RajeshCheruku_NMLS_2658067.jpg";
import staff_JegadheesanJayavel_2686128 from "../../PicesForPages/staff_JegadheesanJayavel.jpg";
import Staff_SreekanthReddyChalla_NMLS_2275417 from "../../PicesForPages/Staff_SreekanthReddyChalla_NMLS_2275417.jpg";
import staff_SubbuKemisetti_NMLS_2699154 from "../../PicesForPages/staff_SubbuKemisetti_NMLS_2699154.jpg";
import Staff_SwathiSolipuram_NMLS_2575114 from "../../PicesForPages/Staff_SwathiSolipuram_NMLS_2575114.jpg.jpeg";
import Staff_JeromeMariarathinam_NMLS_2711299 from "../../PicesForPages/Staff_JeromeMariarathinam.jpeg";
import Staff_SurekhaRamanaiah_NMLS_2490122 from "../../PicesForPages/Staff_SurekhaRamanaiah_NMLS_2490122.jpeg";
import Staff_KarthikaThesingupandi_NMLS_2687553 from "../../PicesForPages/Staff_KarthikaThesingupandi_NMLS_2687553.jpeg";
import Staff_TanviAshishJadhav_NMLS_2690887 from "../../PicesForPages/Staff_TanviAshishJadhav_NMLS_2690887.jpeg";
import staff_DhumpaRaghuram_NMLS_2842662 from "../../PicesForPages/staff_DhumpaRaghuram_NMLS_2842662.jpg";

import { Link } from "react-router-dom";

function YourTeamMembers() {
  const teamMembers = [
    {
      name: "Ramesh Nagarajan",
      role: "LO - FL, GA, NJ, NC, PA, SC, TX & VA",
      photo: Staff_RameshNagarajan_2017892,
      link: "ramesh-nagarajan",
      nmls: "2017892",
    },
    {
      name: "Sridhar Parepalli",
      role: "Loan Originator - MD, NC, OR & SC",
      photo: staff_SridharParepalli_1789686,
      link: "sridhar-parepalli",
      nmls: "1789686",
    },
    {
      name: "Visvesh Balasubramanian",
      role: "Loan Originator - NC",
      photo: staff_VisveshBalasubramanian_2629696,
      link: "visvesh-balasubramanian",
      nmls: "2629696",
    },
    {
      name: "Jegadheesan Jayavel",
      role: "MLO - AL, CO, FL, GA, MD, NC, OR, PA, TX & VA",
      photo: staff_JegadheesanJayavel_2686128,
      link: "jegadheesan-jayavel",
      nmls: "2686128",
    },
    {
      name: "Sreekanth Reddy Challa",
      role: "Loan Originator - VA",
      photo: Staff_SreekanthReddyChalla_NMLS_2275417,
      link: "sreekanth-reddy-challa",
      nmls: "2275417",
    },
    {
      name: "Rajesh Cheruku",
      role: "Loan Originator - VA",
      photo: staff_RajeshCheruku_NMLS_2658067,
      link: "rajesh-cheruku",
      nmls: "2649552",
    },
    {
      name: "Subbu Kemisetti",
      role: "Loan Originator - VA",
      photo: staff_SubbuKemisetti_NMLS_2699154,
      link: "subbu-kemisetti",
      nmls: "2699154",
    },
    {
      name: "Naga Prathusha Bachu",
      // role: "Loan Originator - GA, NC, PA, TX & VA",
      role: "Loan Originator - GA, NC, PA & VA",
      photo: blankPhoto,
      link: "naga-bachu",
      nmls: "2028051",
    },
    {
      name: "Mrs Swathi Solipuram",
      role: "Loan Originator - TX",
      photo: Staff_SwathiSolipuram_NMLS_2575114,
      link: "swathi-solipuram",
      nmls: "2575114",
    },
    {
      name: "Jerome Mariarathinam",
      role: "Loan Originator - VA",
      photo: Staff_JeromeMariarathinam_NMLS_2711299,
      link: "jerome-mariarathinam",
      nmls: "2711299",
    },
    {
      name: "Ashwin Musuku",
      role: "Loan Originator - GA & NC",
      photo: blankPhoto,
      link: "ashwin-musuku",
      nmls: "2692292",
    },
    {
      name: "Gokul Gopalasamy",
      role: "Loan Originator - AL, OR, TX & WA",
      photo: blankPhoto,
      link: "gokul-gopalasamy",
      nmls: "1820273",
    },
    {
      name: "Surekha Ramanaiah",
      role: "Loan Originator - OR",
      photo: Staff_SurekhaRamanaiah_NMLS_2490122,
      link: "surekha-ramanaiah",
      nmls: "2490122",
    },
    {
      name: "Pooja Mahanthesh",
      role: "Loan Originator - TX",
      photo: blankPhoto,
      link: "pooja-mahanthesh",
      nmls: "2690514",
    },
    {
      name: "Tanvi Ashish Jadhav",
      role: "Loan Originator - OR & TX",
      photo: Staff_TanviAshishJadhav_NMLS_2690887,
      link: "tanvi-ashish-jadhav",
      nmls: "2690887",
    },
    {
      name: "Shrinivashan Shanmuogam",
      role: "Loan Originator - OR",
      photo: blankPhoto,
      link: "shrinivashan-shanmuogam",
      nmls: "2659119",
    },
    {
      name: "Srinivas Kunchala",
      role: "Loan Originator - VA",
      photo: blankPhoto,
      link: "srinivas-kunchala",
      nmls: "2818273",
    },
    {
      name: "Karthika Thesingupandi",
      role: "Loan Originator - NC",
      photo: Staff_KarthikaThesingupandi_NMLS_2687553,
      link: "karthika-thesingupandi",
      nmls: "2687553",
    },
    {
      name: "Srinivasa Rao Yarlagadda",
      role: "Loan Originator - CO",
      photo: blankPhoto,
      link: "srinivasa-rao-yarlagadda",
      nmls: "2027043",
    },
    {
      name: "Raghuram Dhumpa",
      role: "Loan Originator - FL, GA & TX",
      photo: staff_DhumpaRaghuram_NMLS_2842662,
      link: "raghuram-dhumpa",
      nmls: "2842662",
    },
    // {
    //     name: 'Coming Soon',
    //     role: '---- ---------',
    //     photo: blankPhoto,
    //     link: '#',
    //     nmls: '-------',
    // },
  ];

  return (
    <div className="teamBoxParent">
      <div className="teamBox">
        <span className="teamHeading">Meet Our Family</span>
        <span className="teamContent">
          Our team at Prime Home Mortgage, INC is fast, friendly, experienced,
          and here to help you every step of the process!
        </span>
        <div className="teamListBoxParent">
          {teamMembers.map((member, index) => (
            <Link
              to={member.link !== "#" ? `/our-family/${member.link}` : "#"}
              className="teamListBox"
              key={index}
            >
              <span className="teamListSpanImage">
                <img
                  fetchPriority="high"
                  loading="eager"
                  src={member.photo}
                  alt={member.name}
                />
              </span>
              <span className="teamListNameOfficer">
                <span className="teamListName">{member.name}</span>
                <span className="teamListOfficer">{member.role}</span>
                <span className="teamListOfficer">NMLS#: {member.nmls}</span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default YourTeamMembers;
